// This is a skeleton starter React component generated by Plasmic.
// This file is owned by you, feel free to edit as you see fit.
import * as React from "react";
import { PlasmicWebHomepage3B } from "./plasmic/o_21_p_0_0_2_prod/PlasmicWebHomepage3B";
import { Helmet } from "react-helmet-async";

function WebHomepage3B_(props, ref) {
  return (
            <>
              <Helmet>
                
              </Helmet>
        
              <PlasmicWebHomepage3B root={{ ref }} {...props} />
            </>
          );
}

const WebHomepage3B = React.forwardRef(WebHomepage3B_);

export default WebHomepage3B;
